import { Component, Inject } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { EventBusService } from '../../../services/event-bus.service';
import { BatchService } from '../../../services/batch.services';
import { MedicineService } from '../../../services/medicine.services';
import { MessageService } from '../../../services/message.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { PrintService } from 'src/services/print.service';
import { AlertComponent } from 'src/components/alert/alert.component';

@Component({
  selector: 'rm-product-label-dialog',
  templateUrl: './product-label.component.html',
  styleUrls: ['./product-label.component.css']
})
export class ProductLabelDialogComponent implements OnInit {
  
  subscriptions: any[] = [];
  products: any;
  gcp: string;
  selectedProduct: any;
  success: boolean = false;
  printCount: number = 1;

  labelImg: string = '';
  hri: any;

  labels: any[] = [];
  formats: any[];
  selectedFormat: string;

  constructor(
    private dialogRef: MatDialogRef<ProductLabelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private batchService: BatchService,
    private medicineService: MedicineService,
    private msgService: MessageService,
    private globalCfgService: GlobalCfgService,
    private printService: PrintService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    if (!this.gcp) {
        this.gcp = this.globalCfgService.getGcp();
    }
    this.loadProducts();
    this.loadFormats();
  }

  loadProducts() {
    this.medicineService.getList(this.gcp).subscribe((response: any) => {
      this.products = response;
      if (this.products.length > 0) {
        this.selectedProduct = this.products[0].gtin;
      }
    });
  }

  cancel() {
      this.dialogRef.close();
  }

  generateLabel() {
      console.log('generate label: ', this.selectedProduct);

      this.batchService.add({
          gtin: this.selectedProduct,
          serializationType: 'cl'
      }).subscribe(
          (response: any)=> {
            if (response.status) {
              this.success = true;
              this.labelImg = 'data:image/png;base64,' + response.label[0].code;
              this.hri = response.label[0].hri;
            } else {
              this.msgService.showError(this.msgService.labelsCreateFail);
            }
          }
      );

  }

  loadFormats() {
    this.printService.getPrintFormats().subscribe(
      (result: any)=> {
        this.formats = result['data'];
      });
  }

  print(format) {
    if (!format) {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: { 
          note: "Please select a print format before printing",
        },
      });

      return;
    }
    if (this.labels.length > 0) {
      this.labels = [];
    }
    var obj = {
      img: this.labelImg,
      hri: this.hri
    };
    for (var i = 0; i < this.printCount; i++) {
      this.labels.push(obj);
    }
    var printWin = window.open('', 'new div', 'height=400,width=600');
    var htmlStr = this.printService.getHtmlStr(format, this.labels);

    console.log(htmlStr);

    printWin.document.write(htmlStr);
    printWin.print();
    // printWin.close();

    // this.dialogRef.close();
  }
}